// Interpolation utilities
// - Supports both {{var}} and {var}
// - Supports dot-paths like user.firstName or meta.orderTotal
// - Supports optional defaults: {{var|fallback}} or {var|fallback}
// - Unknown variables are left as-is by default (configurable via options.keepUnknown)

function getByPath(obj, path) {
  if (!obj || !path) return undefined
  const parts = String(path).split('.')
  let cur = obj
  for (const p of parts) {
    if (cur == null) return undefined
    cur = cur[p]
  }
  return cur
}

export function flattenObject(input, prefix = '', out = {}) {
  if (input == null || typeof input !== 'object') return out
  for (const [k, v] of Object.entries(input)) {
    const key = prefix ? `${prefix}.${k}` : k
    if (v && typeof v === 'object' && !Array.isArray(v)) {
      flattenObject(v, key, out)
    } else {
      out[key] = v
    }
  }
  return out
}

export function interpolateTemplate(template, vars = {}, options = {}) {
  const keepUnknown = options.keepUnknown !== false // default: keep unknown placeholders
  const str = String(template ?? '')

  // Build a lookup that supports both flat keys and dot paths
  const lookup = { ...vars }

  const replaceWith = (match, path, defVal) => {
    let val = lookup[path]
    if (val === undefined) {
      val = getByPath(lookup, path)
    }
    if (val === undefined || val === null || val === '') {
      if (defVal !== undefined) return String(defVal)
      return keepUnknown ? match : ''
    }
    return String(val)
  }

  // Replace double-brace placeholders first to avoid partial single-brace matches
  let out = str.replace(/\{\{\s*([a-zA-Z0-9_.]+)\s*(?:\|([^}]*))?\}\}/g, replaceWith)
  // Then single-brace placeholders
  out = out.replace(/\{\s*([a-zA-Z0-9_.]+)\s*(?:\|([^}]*))?\}/g, replaceWith)
  return out
}
